import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #fff;
  padding: ${(props: IWrapperProps) => !props.pdfExport && "10px"};
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport && "scale(0.75) translateX(-86px) translateY(-11px)"};
  margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px"};
  overflow: hidden;

  &.animated.delay-9 {
    animation-delay: 1.35s;
  }

  ${mediaMaxWidth.mediumDesktop} {
    margin: ${(props: IWrapperProps) => !props.pdfExport && "10px auto"};
    width: ${(props: IWrapperProps) => !props.pdfExport && "650px"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 40px)"};
  }

  ${mediaMaxWidth.phone} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 20px)"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "5px 10px"};

    .__react_component_tooltip {
      max-width: 180px;
    }
  }
`;

export const Chart = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .chart-item {
    width: 100%;
  }
`;

export const TimeToHireTotal = styled.div`
  width: calc(100% - 40px);
  margin: 20px 0 40px 0;
  display: flex;

  ${mediaMaxWidth.phone} {
    font-size: 0.9em;
    margin: 20px 0;
    width: calc(100% - 20px);
  }
`;

export const Days = styled.span`
  font-weight: 700;
  margin-left: 5px;
  display: flex;
`;

export const TthTooltip = styled.div`
  color: #b7b7b7;
  margin-left: 5px;
  font-size: 0.8em;
  display: flex;
  align-items: center;
`;

export const LineWrapper = styled.div`
  width: calc(100% - 60px);
  height: 10px;
  background-color: #f2008c;
  margin: 60px 0 140px 0;
  position: relative;

  &:before {
    content: "";
    width: 30px;
    height: 30px;
    background-color: #f2008c;
    position: absolute;
    border-radius: 50%;
    top: -10px;
    left: -10px;

    ${mediaMaxWidth.smallDesktop} {
      width: 25px;
      height: 25px;
      top: -7px;
    }

    ${mediaMaxWidth.tablet} {
      width: 20px;
      height: 20px;
      top: -7px;
    }

    ${mediaMaxWidth.phone} {
      width: 15px;
      height: 15px;
      top: -6px;
    }
  }

  &:after {
    content: "";
    width: 30px;
    height: 30px;
    background-color: #f2008c;
    position: absolute;
    border-radius: 50%;
    top: -10px;
    right: -15px;

    ${mediaMaxWidth.smallDesktop} {
      width: 25px;
      height: 25px;
      top: -8px;
    }

    ${mediaMaxWidth.tablet} {
      width: 20px;
      height: 20px;
      top: -7px;
    }

    ${mediaMaxWidth.phone} {
      width: 15px;
      height: 15px;
      top: -6px;
    }
  }

  ${mediaMaxWidth.mediumDesktop} {
    margin: 110px 0 140px 0;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100% - 60px);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100% - 50px);
    height: 5px;
    margin: 100px 0 110px 0;
  }
`;

interface ILineSectionProps {
  width: number;
  before?: string;
}

export const LineSection = styled.span`
  height: 100%;
  display: inline-block;
  width: ${(props: ILineSectionProps) => `${props.width}%}`};
  position: relative;
  text-align: center;
  transition: 0.3s ease-in-out;

  &:before {
    content: "${(props: ILineSectionProps) => props.before}";
    position: absolute;
    bottom: 40px;
    right: -35px;
    text-align: center;
    width: 70px;
    font-size: 0.9em;

    ${mediaMaxWidth.mediumDesktop} {
      transform: rotate(-35deg);
      width: 150px;
      text-align: left;
      right: -130px;
      bottom: 80px;
    }

    ${mediaMaxWidth.tablet} {
      bottom: 70px;
    }

    ${mediaMaxWidth.phone} {
      font-size: 0.65em;
      right: -135px;
      bottom: 70px;
    }
  }

  &:after {
    content: "";
    width: 30px;
    height: 30px;
    background-color: #fff;
    border: 6px solid #f2008c;
    position: absolute;
    border-radius: 50%;
    top: -15px;
    right: -15px;

    ${mediaMaxWidth.smallDesktop} {
      width: 25px;
      height: 25px;
      top: -14.5px;
    }

    ${mediaMaxWidth.tablet} {
      width: 20px;
      height: 20px;
      top: -11px;
    }

    ${mediaMaxWidth.phone} {
      width: 15px;
      height: 15px;
      top: -16px;
    }
  }
`;

export const LineSectionDays = styled.span`
  position: absolute;
  top: ${(props: IWrapperProps) => (props.pdfExport ? "40px" : "65px")};
  font-weight: 700;
  font-size: 0.9em;
  width: 35px;
  right: 0;
  left: 0;
  line-height: 1.1em;
  margin: 0 auto;

  ${mediaMaxWidth.mediumDesktop} {
    ${(props: IWrapperProps) => !props.pdfExport && "top: 60px"};
  }

  ${mediaMaxWidth.smallDesktop} {
    ${(props: IWrapperProps) => !props.pdfExport && "font-size: 0.8em"};
  }

  ${mediaMaxWidth.phone} {
    ${(props: IWrapperProps) => !props.pdfExport && "font-size: 0.65em"};
    ${(props: IWrapperProps) => !props.pdfExport && "top: 40px"};
    ${(props: IWrapperProps) => !props.pdfExport && "padding-left: 5px"};
    ${(props: IWrapperProps) => !props.pdfExport && "width: 30px"};
  }
`;

export const Tip = styled.span`
  cursor: pointer;
  color: #f2008c;
  position: absolute;
  top: 110px;
  font-weight: 500;
  font-size: 0.9em;
  width: 50px;
  right: 0;
  left: 0;
  margin: 0 auto;

  &:hover {
    color: #333;
  }

  ${mediaMaxWidth.smallDesktop} {
    font-size: 0.8em;
    top: 100px;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.65em;
    top: 75px;
    padding-left: 5px;
    width: 30px;
  }
`;

export const StartLabel = styled.label`
  position: absolute;
  width: 60px;
  top: 25px;
  text-align: left;
  left: -10px;
  line-height: 1.2em;
  font-size: 0.8em;
  font-weight: 400;
  color: #000;

  ${mediaMaxWidth.mediumDesktop} {
    font-size: 0.7em;
    width: 45px;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.65em;
    width: 40px;
    top: 15px;
  }
`;

export const EndLabel = styled.label`
  position: absolute;
  width: 60px;
  top: 25px;
  text-align: right;
  right: -15px;
  line-height: 1.2em;
  font-size: 0.8em;
  font-weight: 400;
  color: #000;

  ${mediaMaxWidth.mediumDesktop} {
    font-size: 0.7em;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.65em;
    width: 55px;
    top: 15px;
  }
`;
